import BaseEllipsisText from '@/components/base/BaseEllipsisText';
import { Select, type SelectProps } from 'antd';
import type {
  BaseOptionType,
  DefaultOptionType,
  RefSelectProps,
} from 'antd/es/select';
import type { ReactNode, Ref } from 'react';

export interface BaseSelectProps<
  ValueType = string | number,
  OptionType extends BaseOptionType = DefaultOptionType,
> extends SelectProps<ValueType, OptionType> {
  ref?: Ref<RefSelectProps>;
}

/** 纯文字标签复用实际截断提示，复杂选项保持调用方提供的内容。 */
function renderLabel(label: ReactNode) {
  return typeof label === 'string' || typeof label === 'number' ? (
    <BaseEllipsisText title={String(label)} />
  ) : (
    label
  );
}

/** 选择器统一宽度、清空和标签展示，不加载选项或转换原生选中值。 */
export default function BaseSelect<
  ValueType = string | number,
  OptionType extends BaseOptionType = DefaultOptionType,
>({
  className,
  allowClear = true,
  optionRender = (option) => renderLabel(option.label),
  labelRender = (option) => renderLabel(option.label ?? option.value),
  ...props
}: BaseSelectProps<ValueType, OptionType>) {
  return (
    <Select<ValueType, OptionType>
      {...props}
      allowClear={allowClear}
      optionRender={optionRender}
      labelRender={labelRender}
      className={[
        'base-select [:where(&)]:w-full [:where(&)]:min-w-0',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
